import styles from './template.css';
import template from './template.js';
import {customElement, property} from '@aofl/element';
import {PaymentForm} from '@aoflmkt/payment-form';
import {accessibilityMixin} from '../accessibility-mixin';
import {clickTrackerMixin} from '../click-tracker-mixin';
import {ModalService} from '../modal-service';
import {modalsConfig} from './__config/modals';

/**
 * @summary AcademyPaymentForm
 * @class AcademyPaymentForm
 * @extends {AoflElement}
 */
@customElement('academy-payment-form')
class AcademyPaymentForm extends clickTrackerMixin(accessibilityMixin(PaymentForm)) {
  /**
   *
   * Creates an instance of AcademyPaymentForm.
   */
  constructor() {
    super();
    ModalService.addModals(modalsConfig);
  }

  /**
   * @readonly
   */
  static is = 'academy-payment-form';

  @property({type: Boolean, attribute: true})
  ariaExpandedMonth = false;

  @property({type: Boolean, attribute: true})
  ariaExpandedYear = false;

  /**
   *
   */
  showCvvPopup() {
    ModalService.show('cvvCodeModal');
  }


  /**
   * @param {Event} e
   */
  toggleMonth(e) {
    super.toggleMonth(e);
    this.ariaExpandedMonth = !this.ariaExpandedMonth;
    window.setTimeout(function() {
      const firstListItem = document.querySelector('body > route-view').shadowRoot.querySelector('#page-component').shadowRoot.querySelector('#payment-form').shadowRoot.querySelector('#month-option');
      firstListItem.focus({focusVisible: true});
    }, 100);
  }

  /**
   * @param {Event} e
   */
  updateCardMonth(e) {
    super.updateCardMonth(e);
    this.ariaExpandedMonth = false;
  }

  /**
   * @param {Event} e
   */
  toggleYear(e) {
    super.toggleYear(e);
    this.ariaExpandedYear = !this.ariaExpandedYear;
    window.setTimeout(function() {
      const firstListItem = document.querySelector('body > route-view').shadowRoot.querySelector('#page-component').shadowRoot.querySelector('#payment-form').shadowRoot.querySelector('#year-option');
      firstListItem.focus({focusVisible: true});
    }, 100);
  }

  /**
   * @param {Event} e
   */
  updateCardYear(e) {
    super.updateCardYear(e);
    this.ariaExpandedYear = false;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default AcademyPaymentForm;
